'use strict';
angular.module('TurneroApp').component('coConfirmacionExterno', {
	bindings: {
		turnoDetalle: '<',
		ctrlPadre: '=',
		modalidad: '<',
		pkPersona: '<',
		fechaDia: '<'
	},
	controller: [
		'$window',
		'turnosService',
		'$state',
		'$rootScope',
		'$scope',
		'TurneroAppConstant',
		'utilsService',
		'$localStorage',
		'$mdDialog',
		  '$q',
function ($window, turnosService, $state, $rootScope, $scope, TurneroAppConstant, utilsService, $localStorage, $mdDialog, $q) {
	var ctrl = this;
	ctrl.Turno = null
	ctrl.EmailTasas = null;
	ctrl.limpiarMemoria = function () {
		ctrl.ctrlPadre.limpiarMemoria();
	}

	//LOADING BLOCK (SOLO COPIAR)
	ctrl.loading = true;
	ctrl.ajaxArray = [];
	ctrl.d1 = $q.defer();
	ctrl.d2 = $q.defer();
	ctrl.d3 = $q.defer();

	ctrl.ajaxArray.push(ctrl.d1.promise)
	ctrl.ajaxArray.push(ctrl.d2.promise)
	ctrl.ajaxArray.push(ctrl.d3.promise)

	$q.all(ctrl.ajaxArray).then(function () {
		ctrl.loading = false;
	});
	//---------------------------

	ctrl.$onChanges = function () {
		if (ctrl.turnoDetalle && ctrl.fechaDia) {
			ctrl.Turno = ctrl.turnoDetalle;
			ctrl.getConfirmacionesDocumentos();
		}
	};

	ctrl.cancelar = function () {
		ctrl.ctrlPadre.regresarCalendario();
	}

    ctrl.onClickAceptar = function () {
        if (ctrl.Id_Tramite_Aplicacion && (ctrl.appExterna && ctrl.appExterna.Columnas.length > 0))
            ctrl.ConfirmacionAppExterna();
        else
            ctrl.GuardarTurno();
    }

	ctrl.GenerarTasas = function () {
		//dump function
		return true;
	}

	ctrl.getConfirmacionesDocumentos = function () {
		if (ctrl.Turno != null) {
			var Get_Preconfirmacion_Service = ctrl.modalidad == TurneroAppConstant.Modalidades.OnLine ? turnosService.Get_PreConfirmacion_Online :
		(ctrl.modalidad == TurneroAppConstant.Modalidades.Presencial ? turnosService.Get_PreConfirmacion_Asistencia : null)
			if (Get_Preconfirmacion_Service) {
				var filtro = {
					Id_Agenda: ctrl.Turno.Centro.agenda_Seleccionada.id,
					Id_Tramite_Relevado: ctrl.Turno.Tramite.Id_Tramite_Relevado
				}
				if (ctrl.modalidad == TurneroAppConstant.Modalidades.Presencial) {
					if (ctrl.ctrlPadre.N_Ciudadano || ctrl.pkPersona) {
						filtro.N_Ciudadano = ctrl.ctrlPadre.N_Ciudadano ? ctrl.ctrlPadre.N_Ciudadano : (ctrl.pkPersona.Datos_Cidi.N_Ciudadano_Cidi ? ctrl.pkPersona.Datos_Cidi.N_Ciudadano_Cidi : null)
					} else {
						sweetAlert("La persona ingresada no existe", '', "warning");
						return;
					}
				}
				utilsService.swalNotification('Un momento...', 'Obteniendo datos...', 'info');
				Get_Preconfirmacion_Service({ 'filtro.Id_Agenda': filtro.Id_Agenda, 'filtro.Id_Tramite_Relevado': filtro.Id_Tramite_Relevado, 'filtro.N_Ciudadano': filtro.N_Ciudadano }).$promise.then(function (resultado) {
					ctrl.d1.resolve()
					ctrl.preConfirmacion = resultado.Data;
					ctrl.Turno.Centro = {
						Domicilio: ctrl.preConfirmacion.Domicilio,
						N_Centro_Atencion: ctrl.preConfirmacion.N_Centro_Atencion,
						agenda_Seleccionada: ctrl.Turno.Centro.agenda_Seleccionada
					}

					ctrl.documentacionTramite = resultado.Data.Tramite;
					ctrl.Turno.Notifica = {
						Mail: 'N',
						Telefono: 'N'
					}
					ctrl.mostrarCampos = {
						Datos_Adicionales: resultado.Data.Permite_Datos_Adicionales == 'S',
						Observaciones: resultado.Data.Permite_Observaciones == 'S'
					}
					swal.close();
				}).catch(function (error) {
					swal.close();
					ctrl.d1.resolve()
					utilsService.errores(error);
				});
			}
		}
	}
	ctrl.obtenerEmail = function () {
		swal.close();
		$mdDialog.show({
			template: require('../../components/asistencia/modalEmailTasas.html'),
			parent: angular.element(document.body),
			clickOutsideToClose: false,
			escapeToClose: false,
			fullscreen: false, // Only for -xs, -sm breakpoints.,
			controllerAs: '$ctrl',
			controller: function () {
				return ctrl;
			}
		});
	}

	ctrl.aceptarEmail = function () {
		if (ctrl.EmailTasas.length) {
			ctrl.GuardarTurno();
		};
	}

    ctrl.GuardarTurno = function () {
        utilsService.swalNotification('Un momento...', 'Reservando Turno...', 'info');
        if (ctrl.GenerarTasas()) {
            if (((ctrl.pkPersona && !ctrl.pkPersona.Datos_Cidi.EMail) && !ctrl.EmailTasas) && ctrl.input_Tasas_Tramite && ctrl.modalidad == TurneroAppConstant.Modalidades.Presencial) {
                ctrl.obtenerEmail()
                return;
            }
            var Turno = {
                //03/06/2019 Se va a enviar en formato simil ISO pero SIN Timezone
                //Fec_Turno_string: (ctrl.Turno.Datos.dia.getDate().toString() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1).toString() + '/' + ctrl.Turno.Datos.dia.getFullYear().toString() + ' ' + ctrl.Turno.Datos.hora),
                N_Usuario_Cidi: ctrl.pkPersona.Datos_Cidi.N_Ciudadano_Cidi,
				Fec_Turno: ctrl.Turno.Datos.dia.getFullYear() + '-' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '-' + ctrl.Turno.Datos.dia.getDate() + 'T' + ctrl.Turno.Datos.hora,
                Id_Tramite_Relevado: ctrl.Turno.Tramite.Id_Tramite_Relevado,
                Id_Modalidad: ctrl.modalidad,
                Datos_Adicionales: ctrl.Turno.Datos_Adicionales ? ctrl.Turno.Datos_Adicionales : '',
                Observaciones: ctrl.Turno.Observaciones ? ctrl.Turno.Observaciones : '',
                Notificar_Sms: ctrl.Turno.Notifica.Telefono,
                Notificar_Email: ctrl.Turno.Notifica.Mail,
                Nro_Ticket: '',
                Sujeto_Ley_9131: '',
                Id_Agenda: parseInt(ctrl.Turno.Centro.agenda_Seleccionada.id),
                //Id_Prioridad: '', //24/04/2019 Si se envía como un empty string donde corresponde un int el backend lo rechaza en .NET Core
                Nro_Codigo: ctrl.Turno.Codigo ? ctrl.Turno.Codigo : '',
                //24/04/2019 Estaba mal hecho, ya que usar la variable interna "_i" lo único que hace es devolver el valor string de entrada, el cual NO corresponde al formato ISO_8601
                //Fec_Solicitado: moment(ctrl.Turno.Datos.dia.getDate() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '/' + ctrl.Turno.Datos.dia.getFullYear() + 'T' + ctrl.Turno.Datos.hora, moment.ISO_8601)._i,
                //03/06/2019 SE COMPROBÓ QUE NO LO USA EL BACKEND
                //Fec_Solicitado: ctrl.Turno.Datos.dia.getFullYear() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '/' + ctrl.Turno.Datos.dia.getDate() + 'T' + ctrl.Turno.Datos.hora,
                I_AppExterna: ctrl.input_App_Externa ? ctrl.input_App_Externa : null,
                Tasas: ctrl.input_Tasas_Tramite ? ctrl.input_Tasas_Tramite : null,
                Email: ctrl.modalidad == TurneroAppConstant.Modalidades.Presencial && !ctrl.pkPersona.Datos_Cidi.EMail ? ctrl.EmailTasas : null
            };

            if (ctrl.modalidad == TurneroAppConstant.Modalidades.Presencial) {
                if (ctrl.pkPersona) {
                    Turno.Id_Sexo = ctrl.pkPersona.Datos_RegistroCivil == null ? null : ctrl.pkPersona.Datos_RegistroCivil.Id_Sexo
                    Turno.Id_Numero = ctrl.pkPersona.Datos_RegistroCivil == null ? null : ctrl.pkPersona.Datos_RegistroCivil.Id_Numero
                    Turno.Nro_Documento = ctrl.pkPersona.Datos_RegistroCivil == null ? null : ctrl.pkPersona.Datos_RegistroCivil.Nro_Documento
                    Turno.Pai_Cod_Pais = ctrl.pkPersona.Datos_RegistroCivil == null ? null : ctrl.pkPersona.Datos_RegistroCivil.Pai_Cod_Pais
					Turno.N_Usuario_Cidi = ctrl.pkPersona.Datos_Cidi.N_Ciudadano_Cidi
                } else {
                    sweetAlert("La persona ingresada no existe", '', "warning");
                    return;
                }
            }

            var turnoPostService = ctrl.modalidad == TurneroAppConstant.Modalidades.OnLine ? turnosService.Post_Turno_Online :
                (ctrl.modalidad == TurneroAppConstant.Modalidades.Presencial ? turnosService.Post_Turno_Presencial : null)
            if (turnoPostService) {
                turnoPostService(Turno).$promise.then(function (resultado) {
                    swal.close();
                    if (resultado.Data) {
                        var turnoDetalle = {
                            N_Tramite: ctrl.Turno.Tramite.N_Tramite,
                            N_Centro_Atencion: ctrl.Turno.Centro.N_Centro_Atencion,
                            Fec_Turno: ctrl.Turno.Datos.dia.getDate() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '/' + ctrl.Turno.Datos.dia.getFullYear(),
                            Hora_Desde: ctrl.Turno.Datos.hora,
                            Domicilio: ctrl.Turno.Centro.Domicilio,
                            Id_Turno: resultado.Data.Id_Turno,
                            Mensaje_Respuesta: resultado.Data.Mensaje
                        }

                        window.parent.postMessage("Turno Grabado", "*");

                        ctrl.reimprimirTurno(turnoDetalle);
                    }
                }).catch(function (error) {
                    swal.close();
                    utilsService.errores(error);
                })
            }
        } else {
            swal.close()
            sweetAlert("Faltan completar datos", 'Se deben completar todos los datos de tasas retributivas.', "warning");
        }
    };

	ctrl.reimprimirTurno = function (turno) {
		ctrl.OcultarRegresar = true
		ctrl.turnoSeleccionado = turno;
		if (ctrl.modalidad == TurneroAppConstant.Modalidades.Presencial) {
			ctrl.turnoSeleccionado.usuario = {
				//nombre: ctrl.pkPersona.Datos_RegistroCivil.Nombre,
				nombre: ctrl.pkPersona.Datos_Cidi.NombreYApellido,
				CUIT: utilsService.CUIL_Formateado(ctrl.ctrlPadre.N_Ciudadano ? ctrl.ctrlPadre.N_Ciudadano : (ctrl.pkPersona.Datos_Cidi.N_Ciudadano_Cidi ? ctrl.pkPersona.Datos_Cidi.N_Ciudadano_Cidi : null))
			};
		} else {
			ctrl.turnoSeleccionado.usuario = {
				nombre: $localStorage.TurneroApp_Authorization.usuario.nombre,
				CUIT: utilsService.CUIL_Formateado($localStorage.TurneroApp_Authorization.usuario.CUIL)
			};
		}

		$mdDialog.show({
            template: require('../../components/turnos/turnosOnline/modalComprobante.html'),
			parent: angular.element(document.body),
			clickOutsideToClose: false,
			escapeToClose: false,
			fullscreen: false, // Only for -xs, -sm breakpoints.,
			controllerAs: '$ctrl',
			controller: function () {
				return ctrl;
			}
		});
    };

	ctrl.cerrarModal = function () {
		ctrl.OcultarRegresar = false;
		$mdDialog.destroy();
	};

	ctrl.ImprimirComprobante = function (Id_Turno) {
        $window.open('reimprimir?Id_Turno=' + Id_Turno + '&Desde_Ciudadano=false', '_blank');
	};
	
}],
	template: require('../../components/turnos/turnosOnline/turnoOnlineConfirmacion.html')
});


// WEBPACK FOOTER //
// ./app/shared/calendarioExterno/confirmacionExternaComponent.js